import { Box, colors, unit } from '@acast/decibel';
import styled from 'styled-components';

export const List = styled(Box).attrs({ as: 'ul' })`
  display: block;
  background-color: ${colors.black2};
  border: solid 1px ${colors.black16};
  border-radius: 4px;
`;

export const ListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${unit(3)};

  & + & {
    border-top: solid 1px ${colors.black16};
  }
`;
